<div class="wrapper bg-area">
  <section id="login">
    <div class="container area-faca-parte">
      <div class="header-faca-parte columns">
        <div class="column is-6">
          <h3 class="title">Monte seu Plano</h3>
          <p>Configure sua assinatura de hotéis do seu jeito. <br *ngIf="isMobile"> Não leva mais do que 3 minutos!</p>
          <div class="bar__container" *ngIf="!isMobile">
            <ul class="bar" id="bar">
              <li class="active active-step"><i class="fas fa-check"></i>Plano</li>
              <li class="active active-step"><i class="fas fa-check"></i>Dados Pessoais</li>
              <li class="active">Pagamento</li>
              <li>Segurança</li>
              <li>Confirmação</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="sample-form" *ngIf="!isMobile">
        <div class="body-faca-parte columns">
          <div class="column is-6">

            <form class="dados-pessoais" [formGroup]="form">

              <h4>Bem-vindo(a) de volta, {{cliente.primeiroNome}}!</h4>
              <p>
                <strong>Quanto tempo!</strong><br><br>
                Para Continuar, vou precisar da sua senha, a mesma que você usava no Portal do Cliente, e depois
                confirmar seus dados. É rapidinho!
              </p>


              <div class="field forms-dados" tabindex="1">
                <label class="email" name="email">E-mail</label>
                <input name="email" type="email" formControlName="username" placeholder="E-mail" required>
                <span class="campo-erro" *ngIf="form.invalid">{{getErrorMessage('username')}}</span>
                <a href="/etapa-email" class="link-verde">Não sou o {{cliente.primeiroNome}}</a>
              </div>

              <div class="field forms-dados" tabindex="1">
                <input name="senha"
                       type="password"
                       formControlName="password"
                       placeholder="Senha"
                       maxlength="4"
                       (keypress)="omitSpecialChar($event)"
                       required>
                <span class="campo-erro" *ngIf="form.invalid">{{getErrorMessage('password')}}</span>
                <a href="/esqueci-senha" class="link-verde">Esqueci minha senha</a>
              </div>

            </form>
          </div>
          <div class="column is-6 resumo-compra" *ngIf="propostaResult">
            <div class="area-fixed-resumo">
              <div class="seu-plano">
                <h4>Seu Plano</h4>

                <label class="small-label label-pessoas">
                  <span><i class="fas fa-user-plus"></i> <strong>{{countPessoas}}</strong> Pessoas</span>
                </label>
                <label class="small-label">
                  <span><i class="fas fa-bed"></i> <strong>{{propostaResult ? propostaResult.quartoDuplo : '0'}}</strong>
                    Quarto <br><span class="coluna-left">Duplo</span></span>
                </label>
                <label class="small-label">
                  <span><i class="fas fa-bed"></i> <strong>{{propostaResult ? propostaResult.quartoTriplo : '0'}}</strong>
                    Quartos <br><span class="coluna-left">Triplo</span></span>
                </label>
                <br>
                <p class="colunas"><span>Plano {{categoriaTituloDescritivo()}}</span><span
                    class="coluna-right">{{countDiarias}}
                    diárias</span></p>
                <p class="colunas"><span>Taxa de Adesão</span><span class="coluna-right" appCurrencyMask>
                    {{propostaResult ? propostaResult.valorAdesao.toString() : '0' }}</span>
                </p>
                <p class="colunas"><span><strong>Total</strong></span><span class="coluna-right"><strong>
                      {{propostaResult ? propostaResult.valorMensalidade.toString() : '0'}}</strong></span>
                </p>

                <p class="add-cupom"><strong><i class="fas fa-ticket-alt"></i>Cupom</strong></p>

                <input type="text" [(ngModel)]="cupom" class="sucess" placeholder="Insira um cupom" name="cupom"
                  (input)="limpacupom()">
                <label class="text-sucess" *ngIf="isCupomValido == null && cupom" style="cursor: pointer;"
                  (click)="validaCupom()">Aplicar cupom</label>
                <label class="text-sucess" *ngIf="isCupomValido != null && isCupomValido && cupom">Cupom aplicado</label>
                <label class="text-error" *ngIf="isCupomValido != null && !isCupomValido && cupom">O Cupom Não
                  Existe</label>
                <p *ngIf="mensagemCupom" class="prazo-cupom"><small>{{mensagemCupom}}</small></p>
                <p *ngIf="!mensagemCupom">&nbsp;</p>

                <p class="valores-cupom"><strong>Taxa de adesão</strong> <span>De</span> <span class="line-through">R$
                    {{propostaResult ? propostaResult.valorAdesao.toString() : '0'}}</span> <small>Por</small> <span
                    class="valor-final"> {{propostaResult ? propostaResult.valorAdesaoDesconto.toString() : '0'}}</span>
                </p>

                <p class="valores-cupom"><strong>Mensalidade</strong> <span>De</span> <span class="line-through">R$
                    {{propostaResult ? propostaResult.valorMensalidade.toString() : '0'}}</span> <small>Por</small> <span
                    class="valor-final">{{propostaResult ? propostaResult.valorMensalidadeDesconto.toString() : '0'}}</span>
                </p>

                <p class="valor-plano"><strong>Valor do Plano</strong> <span class="valor"><small>
                    </small>{{propostaResult && propostaResult.valorMensalidadeDesconto && propostaResult.valorMensalidadeDesconto.toString() != 'R$ 0,00' ? propostaResult.valorMensalidadeDesconto : propostaResult.valorMensalidade.toString()}}
                    /
                    <span>mês</span></span></p>
              </div>
              <button type="button" (click)="submit()" class="btn-verde"><i class="fas fa-arrow-right"></i>FINALIZAR
                COMPRA</button>
            </div>
          </div>
        </div>
      </div>
      <form class="form-montreal-plano-home" *ngIf="isMobile" [formGroup]="form">
        <div class="body-faca-parte columns">
          <div class="column is-6">

            <div class="area-proposta">

              <h4>Bem-vindo(a) de volta, {{cliente.primeiroNome}}!</h4>
              <p>
                <strong>Quanto tempo!</strong><br><br>
                Para Continuar, vou precisar da sua senha, a mesma que você usava no Portal do Cliente, e depois
                confirmar seus dados. É rapidinho!
              </p>


              <div class="field forms-dados" tabindex="1">
                <label class="email" name="email">E-mail</label>
                <input name="email" type="email" formControlName="username" placeholder="E-mail" required>
                <span class="campo-erro" *ngIf="form.invalid">{{getErrorMessage('username')}}</span>
                <a href="/etapa-email" class="link-verde">Não sou o {{cliente.primeiroNome}}</a>
              </div>

              <div class="field forms-dados" tabindex="1">
                <input name="senha" type="password" formControlName="password" placeholder="Senha" required>
                <span class="campo-erro" *ngIf="form.invalid">{{getErrorMessage('password')}}</span>
                <a href="/esqueci-senha" class="link-verde">Esqueci minha senha</a>
              </div>

            </div>
          </div>
          <div class="column is-6 resumo-compra" *ngIf="propostaResult">
            <div class="area-fixed-resumo" *ngIf="isMobile">
              <div class="seu-plano">
                <div class="input-cupom">
                  <label class="text-sucess icon-cupom">
                    <i class="fas fa-ticket-alt"></i>
                  </label>
                  <input type="text" [(ngModel)]="cupom" class="sucess" placeholder="Insira um cupom" name="cupom" (input)="limpacupom()">
                  <label class="text-sucess" *ngIf="isCupomValido == null && cupom" style="cursor: pointer;" (click)="validaCupom()">
                    Aplicar
                  </label>
                  <label class="text-sucess" *ngIf="isCupomValido != null && isCupomValido && cupom">
                    Aplicado
                  </label>
                  <label class="text-error" *ngIf="isCupomValido != null && !isCupomValido && cupom">
                    Não Existe
                  </label>
                  <p *ngIf="mensagemCupom" class="prazo-cupom"><small>{{mensagemCupom}}</small></p>
                  <p *ngIf="!mensagemCupom">&nbsp;</p>
                </div>
                <div class="total">
                  <p *ngIf="!mensagemCupom">&nbsp;</p>

                  <div *ngIf="isCupomValido != null && isCupomValido && cupom">
                    <h4>
                      <strong>Taxa de adesão</strong>
                    </h4>
                    <p class="valores-cupom">
                      <small>De  </small>
                      <span class="line-through" style="padding-left: 5%">
                        {{propostaResult ? propostaResult.valorAdesao.toString() : '0'}}
                        </span>
                    </p>
                    <p class="valores-cupom vc2">
                      <small>Por</small>
                      <span class="valor-final"> {{propostaResult ? propostaResult.valorAdesaoDesconto.toString() : '0'}}</span>
                    </p>
                  </div>


                  <div *ngIf="!isCupomValido">
                    <h4>
                      <strong>Taxa de adesão</strong>
                    </h4>
                    <p class="valores-cupom">
                      <span></span>
                      <span class="line-through"></span>
                    </p>
                    <p class="valores-cupom vc2">
                      <small></small>
                      <span class="valor-final"> {{propostaResult.valorAdesao.toString()}}</span>
                    </p>
                  </div>



                  <div>
                    <h4>
                      <strong>Valor do Plano</strong>
                    </h4>
                    <p class="valor-plano">
                        <span class="valor">
                      <small></small>
                          {{propostaResult && propostaResult.valorMensalidadeDesconto && propostaResult.valorMensalidadeDesconto.toString() != 'R$ 0,00' ? propostaResult.valorMensalidadeDesconto : propostaResult.valorMensalidade.toString()}}
                          /
                      <span>mês</span>
                      </span>
                    </p>
                  </div>

                  <div class="btn-mobile">
                    <button type="button" (click)="submit()" class="btn-verde"><i class="fas fa-arrow-right"></i>FINALIZAR COMPRA</button>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </section>

</div>
